import axios from "axios";
import config from "../baseConfig/index";
import { localStorageGetItem, localStorageSetItem } from "../storage/index";
import Cookies from "js-cookie";
import SimpleCrypto from "simple-crypto-js";

class ApiManager {
  static getUrlWithLng(url) {
    const defaultLngPrefix = localStorageGetItem("defaultLngPrefix");

    if (
      defaultLngPrefix !== "hy" &&
      defaultLngPrefix !== "ru" &&
      defaultLngPrefix !== "en"
    ) {
      localStorageSetItem("defaultLngPrefix", config.defaultLngPrefix);
    }

    return (
      config.apiUrl + (localStorageGetItem("defaultLngPrefix") || "hy") + url
    );
  }

  static convertDataToFormData(data) {
    let formData = new FormData();

    for (let key in data) {
      formData.append(key, data[key]);
    }

    return formData;
  }

  static getTranslations() {
    if (!localStorageGetItem("defaultLngPrefix")) {
      localStorageSetItem("defaultLngPrefix", config.defaultLngPrefix);
    }

    let hash = window.location.hash.replace("#", "");

    if (hash === "hy" || hash === "ru" || hash === "en") {
      localStorageSetItem("defaultLngPrefix", hash);
      window.history.pushState("", document.title, window.location.pathname);
    }

    const result = axios.get(
      config.translationUrl +
        "translations/" +
        localStorageGetItem("defaultLngPrefix") +
        ".json?v=" +
        config.transVersion
    );
    result.catch(this.requestError);
    return result;
  }

  static getB2bTranslations() {
    const result = axios.get(
      config.translationUrl +
        "translations/b2b/" +
        localStorageGetItem("defaultLngPrefix") +
        ".json?v=" +
        config.transVersion
    );

    result.catch(this.requestError);

    return result;
  }

  static signOut(data) {
    const result = axios.post(
      this.getUrlWithLng("/logout"),
      this.convertDataToFormData(data),
      {
        withCredentials: true,
        headers: {
          Authorization: "Bearer " + data.jwt,
        },
      }
    );

    result.catch(this.requestError);
    return result;
  }

  static getRequest(data, url) {
    const headerObj = data.jwt
      ? {
          params: data,
          withCredentials: true,
          // headers: {
          //   Authorization: "Bearer " + data.jwt,
          // }
        }
      : {
          params: data,
          withCredentials: true,
        };
    const makeRequest = () => axios.get(this.getUrlWithLng(url), headerObj);

    const result = makeRequest().then(async (response) => {
      if (response.data.status === "TOKENEXPIRED") {
        try {
          const newAccess = await this.refreshAccessToken();

          if (!data) {
            data = {};
          }

          data.jwt = newAccess;
          headerObj.params = data;

          return makeRequest();
        } catch (e) {
          return Promise.reject(e);
        }
      }

      if (response.data.status === "UNAUTHORIZED") {
        this.handleUnauthorized();
      }
      return response;
    });
    result.catch(this.requestError);

    return result;
  }

  static postRequest(data, url) {
    const makeRequest = (d) =>
      axios.post(this.getUrlWithLng(url), this.convertDataToFormData(d), {
        withCredentials: true,
      });

    const result = makeRequest(data).then(async (response) => {
      if (response.data.status === "TOKENEXPIRED") {
        try {
          const newAccess = await this.refreshAccessToken();
          const newData = { ...(data || {}), jwt: newAccess };
          return makeRequest(newData);
        } catch (e) {
          return Promise.reject(e);
        }
      }

      if (response.data.status === "UNAUTHORIZED") {
        this.handleUnauthorized();
      }

      return response;
    });

    result.catch(this.requestError);

    return result;
  }

  static handleUnauthorized() {
    document.cookie = `loginToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${config.urlPrefix};`;
    document.cookie = `refreshToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${config.urlPrefix};`;
    window.location.href = "/myaccount/";
  }

  static requestError(error) {
    console.log(error);
  }
  static async refreshAccessToken() {
    try {
      const encryptedRefresh = Cookies.get("refreshToken");

      if (!encryptedRefresh) {
        this.handleUnauthorized();
        return Promise.reject(new Error("No refresh token"));
      }

      const simpleCrypto = new SimpleCrypto(config.simpleCryptoSecretKey);
      let refreshToken;

      try {
        refreshToken = simpleCrypto.decrypt(encryptedRefresh);
      } catch (e) {
        this.handleUnauthorized();
        return Promise.reject(e);
      }

      const response = await axios.get(this.getUrlWithLng("/refresh-token"), {
        params: { jwt: refreshToken },
        withCredentials: true,
      });

      if (
        response.data.status === "TOKENEXPIRED" ||
        response.data.status === "UNAUTHORIZED"
      ) {
        this.handleUnauthorized();
        return Promise.reject(new Error("Refresh token expired"));
      }

      if (response.data.status === "OK") {
        const { accessToken, refreshToken: newRefresh } = response.data.data;

        Cookies.set("loginToken", simpleCrypto.encrypt(accessToken), {
          path: config.urlPrefix,
        });
        if (newRefresh) {
          Cookies.set("refreshToken", simpleCrypto.encrypt(newRefresh), {
            path: config.urlPrefix,
          });
        }
        window.location.reload();
        return accessToken;
      }
      this.handleUnauthorized();
      return Promise.reject(new Error("Unknown status while refreshing token"));
    } catch (error) {
      this.requestError(error);
      this.handleUnauthorized();
      return Promise.reject(error);
    }
  }
}

export default ApiManager;
